import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from 'src/app/shared/services/rest-service';
import { TagType as TagTypeEnum } from '../enums/tag-type';
import { SearchTagResponse } from 'src/app/core/models/i-search-tag-response';
import { ICreateTagResponse } from 'src/app/core/models/i-create-tag-response';

@Injectable({
  providedIn: 'root',
})
export class TagService {
  private readonly BASE_TAG_ROUTE = `api`;
  private readonly BUILD_HTTP_ROUTE = (...args) =>
    this.restService.BUILD_HTTP_ROUTE(this.BASE_TAG_ROUTE, ...args);

  constructor(private restService: RestService) {}

  get$(
    searchText: string,
    tagType: TagTypeEnum,
  ): Observable<SearchTagResponse> {
    const params = this.restService.buildHttpParamsObject({
      searchText,
      tagType,
    });

    return this.restService.get$<SearchTagResponse>(
      this.BUILD_HTTP_ROUTE('tags'),
      {
        params,
      },
    );
  }

  create$(tagText: string): Observable<ICreateTagResponse> {
    return this.restService.post$<ICreateTagResponse>(
      this.BUILD_HTTP_ROUTE('tags'),
      {
        tagText: tagText,
      },
    );
  }
}
